import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massForceDeleteBlogCategories } from "../../api/apiBlogCategories";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف جماعي نهائي للتصنيفات
 */
export function useForceDeleteAllBlogCategories() {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteAllBlogCategoriesMutate,
        isPending,
    } = useMutation({
        mutationFn: massForceDeleteBlogCategories,
        onSuccess: (response) => {
            toast.success(response.message || "Force deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["blog-categories"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to force delete blog categories");
        },
    });

    return {
        forceDeleteAllBlogCategoriesMutate,
        isPending,
    };
}
